import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Customer } from '../models/customer';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseRestService {

  readonly CUSTOMER_API_URL: string = environment.apiUri + '/customers';
  readonly CUSTOMER_SAVING_API_URL: string = environment.savingUri + '/saving-agreements/customers';

  getById(id: string): Observable<any> {
    return this.httpClient.get(this.CUSTOMER_API_URL + "/" + id,
      { headers: this.headers });
  }

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.CUSTOMER_API_URL, options);
  }

  getSummaryList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.CUSTOMER_API_URL + "/summary", options);
  }

  create(customer: Customer): Observable<any> {
    return this.httpClient.post(this.CUSTOMER_API_URL, JSON.stringify(customer),
      { headers: this.headers });
  }

  update(id: string, customer: Customer): Observable<any> {
    return this.httpClient.put(this.CUSTOMER_API_URL + "/" + id, JSON.stringify(customer),
      { headers: this.headers });
  }
  
  exist(param: string, value: string): Observable<any> {
    return this.httpClient.get(this.CUSTOMER_API_URL + "/exist?" + param + "=" + value,
      { headers: this.headers });
  }

  existIdentityNumber(identityType: string, serialNumber: string): Observable<any> {
    return this.httpClient.get(this.CUSTOMER_API_URL + "/exist?identityType=" + identityType + "&serialNumber=" + serialNumber,
      { headers: this.headers });
  }

  changeStatus(id: string, status: string): Observable<any> {
    return this.httpClient.put(this.CUSTOMER_API_URL + "/change-status" + "/" + id + "?status=" + status,
      { headers: this.headers });
  }

  getCustomerApprovalList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.CUSTOMER_API_URL + "/list-by-status", options);
  }

  changeStatusForItems(ids: string, status: string): Observable<any> {
    return this.httpClient.put(this.CUSTOMER_API_URL + "/change-status" + "/" + ids + "?status=" + status,
      { headers: this.headers });
  }

  getCustomerByAccountNumber(accountNumber: string): Observable<any>{
    return this.httpClient.get(this.CUSTOMER_API_URL + "/accountNumber/" + accountNumber,
        {headers: this.headers,})
  }

  getSubLedgerAccountsByCustomerId(id: string): Observable<any>{
    return this.httpClient.get(this.CUSTOMER_SAVING_API_URL + "/accounts/" + id,
        {headers: this.headers,})
  }

  exportExcel(pageParams): Observable<any> {
    return this.httpClient.get(`${this.CUSTOMER_API_URL}/export`,
        {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams),
            responseType: 'arraybuffer'
        });
  }

  import(formData): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Content-Type", " multipart/form-data");
    return this.httpClient.post(this.CUSTOMER_API_URL + "/import", formData,
        { headers: headers, 
          responseType: 'arraybuffer', 
          observe: 'response' 
        });
  }

    importImage(formData): Observable<any> {
        let headers = new HttpHeaders();
        headers.append("Content-Type", " multipart/form-data");
        return this.httpClient.post(this.CUSTOMER_API_URL + "/import-customer-image-ref", formData,
            { headers: headers,
                responseType: 'arraybuffer',
                observe: 'response'
            });
    }

  delete(data): Observable<any> {
    return this.httpClient.delete(this.CUSTOMER_API_URL, { headers: this.headers, body: JSON.stringify(data) });
  }

}
